export default {
  state: {
    permissions:[] , //  权限标识
    menuList:[],     //  当前所选系统的菜单
    nextMenuList:[],     //  第二/三级菜单
    FMenuList:[],     //  第四级菜单
    userInfo:null,
    ishu:false
  },
  mutations: {
    updatePermissions(state, value) {
      state.permissions = value
    },
    updateMenuList(state, value) {
      state.menuList = value
    },
    updateNextMenuList(state, value) {
      state.nextMenuList = value
    },
    updateFMenuList(state, value) {
      state.FMenuList = value
    },
    updateUserInfo(state, value) {
      state.userInfo = value
    },
    updateIshu(state, value) {
      state.ishu = value
    },
  }
}
